/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DocumentsId,
} from '../models/index';
import {
    DocumentsIdFromJSON,
    DocumentsIdToJSON,
} from '../models/index';

export interface RenderDocumentsRequest {
    documentsId: DocumentsId;
}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI {

    /**
     * Creates request options for renderDocuments without sending the request
     */
    async renderDocumentsRequestOpts(requestParameters: RenderDocumentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['documentsId'] == null) {
            throw new runtime.RequiredError(
                'documentsId',
                'Required parameter "documentsId" was null or undefined when calling renderDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/documents/render`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentsIdToJSON(requestParameters['documentsId']),
        };
    }

    /**
     * Render the documents
     * Render the documents
     */
    async renderDocumentsRaw(requestParameters: RenderDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.renderDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Render the documents
     * Render the documents
     */
    async renderDocuments(requestParameters: RenderDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renderDocumentsRaw(requestParameters, initOverrides);
    }

}
